const baseURL = `${process.env.REACT_APP_BASE_URL}/api/user`

const headers = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
}

// API to get domain list with details
const getUserActivityListApi = async (
    token: string, // access token
    limit: number, // limit of records per page
    offset: number, // record offset 
    startDate : string,  // start date
    endDate : string, // end date
): Promise<any> => {

    let url = `${baseURL}/activity-history?limit=${limit}&offset=${offset}`;

    // Add start_date and end_date if both are provided
    if (startDate !== '' && endDate !== '') {
        const queryParams = new URLSearchParams({
            start_date: startDate,
            end_date: endDate
        });
        url += `&${queryParams.toString()}`;
    }
    
    try {
        const response = await fetch(url, {
            method: 'GET',
             headers: {
                ...headers,
                "Authorization": "Bearer " + token
            }
            // body: data,
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}

const postUserActivityListApi = async (
    token: string, // reset password token
    title:string,
    description:string
): Promise<any> => {

    const url = `${baseURL}/store-activity`;

    const data = new FormData();

    data.append("title", title);
    data.append("description", description);

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                ...headers,
                "Authorization": "Bearer " + token
            },
            body: data
        });
        return await response.status;
    } catch (error) {
        return Promise.reject;
    }

}

export { getUserActivityListApi, postUserActivityListApi }